export const Config =  {
    api: {
        entryPoint: process.env.REACT_APP_API_ENTRYPOINT
    }
};